<template>
  <header class="position-sticky">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3 col-lg-3">
          <div class="logo-container d-none d-md-inline-block">
            <a href="/"><img src="../assets/images/colourhouse.jpeg" class="d-block" alt=""></a>
          </div>

          <a href="/" class="d-inline-block d-md-none"><img src="../assets/images/colourhouse.jpeg" class="logo d-block" alt=""></a>
        </div>
      </div>
    </div>

    <div class="header-border bg-dark d-flex align-items-center">
      <div class="container">
        <div class="row">
          <div class="col-auto" v-for="event in events" :key="event.id">
            <router-link :to="{ name: 'event', params: { id: event.id } }" class="header-link">{{ event.header }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "site-header",
    data() {
      return {
        events: []
      }
    },
    async mounted() {
      let eventsRef = await firebase.firestore().collection(`events`).where("active", "==", true).where("visible", "==", true).orderBy("eventStart")
      let events = await eventsRef.get()
      this.events = await events.docs.map((doc) => {
        return Object.assign({}, { id: doc.id }, doc.data())
      })
    }
  }
</script>

<style lang="scss" scoped>
  // header { height: 61px; }
  header { top: 0; z-index: 1; background-color: #FFF; }

  .logo-container {
    padding: 20px;
  }

  .header-border {
    height: 58px;
  }

  .header-link {
    color: #FFF;

    &:hover {
      text-decoration: underline;
    }
  }
</style>